import { OVERLAY_ROUTE_NAMES, } from "./OverlayRouteMap";
export const MAX_SEARCH_QUERY_LENGTH = 200;
/**
 * Serialize stack entries to URLSearchParams.
 *
 * Examples:
 *   search({ q:"pizza" })        → search=pizza
 *   product({ id:"margherita" }) → product=margherita
 *   cart({})                     → cart=
 */
export function serializeToParams(entries) {
    const params = new URLSearchParams();
    for (const entry of entries) {
        params.set(entry.route, paramValue(entry));
    }
    return params;
}
function paramValue(entry) {
    var _a;
    switch (entry.route) {
        case "product":
            return entry.params.id;
        case "search":
            return (_a = entry.params.q) !== null && _a !== void 0 ? _a : "";
        case "modal":
            return entry.params.id;
        default:
            return "";
    }
}
/**
 * Reconstruct stack from URLSearchParams.
 *
 * Handles ALL overlay routes so that browser back/forward navigation fully
 * restores the overlay stack.  Cold hydration (page refresh) should call this
 * and then filter to HYDRATABLE_ROUTES at the call site.
 *
 * Examples:
 *  search=pizza        → [{ route: "search", params: { q: "pizza" } }]
 *  product=margherita  → [{ route: "product", params: { id: "margherita" } }]
 */
export function deserializeFromParams(params) {
    const entries = [];
    for (const route of OVERLAY_ROUTE_NAMES) {
        const raw = params.get(route);
        if (raw === null)
            continue;
        switch (route) {
            case "product":
                entries.push({ route, params: { id: raw } });
                break;
            case "search":
                entries.push({
                    route,
                    params: {
                        q: raw.slice(0, MAX_SEARCH_QUERY_LENGTH),
                    },
                });
                break;
            case "modal":
                entries.push({ route, params: { id: raw } });
                break;
            default:
                entries.push({
                    route: route,
                    params: {},
                });
        }
    }
    return entries;
}
